import styled from 'styled-components';

export const StyledReportCollection = styled.div`
    font-family: var(--bllink-font-primary);

    form {
        grid-template-rows: repeat(4, 1fr) !important;

        .app-btn {
            grid-column-start: 2;
        }
    }

    @media screen and (max-width: 768px) {
        font-family: var(--bllink-font-secondary);

        form {
            grid-template-rows: repeat(6, 1fr) !important;
    
            .app-btn {
                grid-column-start: 1;
                margin-top: 10px;
            }
        }

    }
`
